<template>
  <div class="small-rounded-btn gkt-btn">
    <slot name="svg" />
  </div>
</template>

<style lang="scss" scoped>
.hand,
.screw-driver {
  :deep(svg) {
    position: relative;
    top: 4px;
  }
}
</style>
